module.exports = __webpack_public_path__ + "img/jojoba.43ac5a49.svg";